<div class="unauthorized-container">
  <div class="unauthorized-content">
    <mat-icon class="error-icon">block</mat-icon>
    <h1>Access Denied</h1>
    
    <div class="message-box" *ngIf="!isApproved">
      <mat-icon>pending</mat-icon>
      <p class="main-message">Your account is pending approval</p>
      <p class="sub-message">
        Please wait for an administrator to approve your account before accessing this system.
      </p>
    </div>

    <div class="message-box" *ngIf="isApproved">
      <mat-icon>lock</mat-icon>
      <p class="main-message">You don't have permission to access this page</p>
      <p class="sub-message">
        Your role ({{ userRole }}) does not have access to the requested resource.
      </p>
    </div>

    <div class="actions">
      <button mat-raised-button color="primary" (click)="goToDefaultPage()">
        <mat-icon>home</mat-icon>
        Go to My Dashboard
      </button>
      
      <button mat-stroked-button (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
        Go Back
      </button>

      <button mat-stroked-button color="warn" (click)="logout()">
        <mat-icon>logout</mat-icon>
        Logout
      </button>
    </div>

    <div class="help-text">
      <mat-icon>help_outline</mat-icon>
      <p>If you believe this is an error, please contact your system administrator.</p>
    </div>
  </div>
</div>